import { AlertTriangle } from "lucide-react";

// Bandeau de sécurité OBLIGATOIRE, non contournable. Texte exact — ne pas modifier.
export const SafetyBanner = () => (
  <div
    data-testid="safety-banner"
    role="alert"
    className="relative bg-[#DC2626] text-white px-4 py-3 shadow-md"
  >
    <div className="flex gap-2.5 max-w-md mx-auto">
      <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5" />
      <p className="text-[13px] leading-snug font-medium">
        En cas de douleur thoracique importante, difficulté à respirer, paralysie, trouble brutal de la
        parole, perte de connaissance, hémorragie importante ou doute sur la gravité, appelez immédiatement le{" "}
        <a href="tel:15" className="font-['JetBrains_Mono'] font-extrabold text-base underline underline-offset-2">15</a>{" "}
        ou le{" "}
        <a href="tel:112" className="font-['JetBrains_Mono'] font-extrabold text-base underline underline-offset-2">112</a>.
        Pour les personnes sourdes ou malentendantes :{" "}
        <a href="tel:114" className="font-['JetBrains_Mono'] font-extrabold text-base underline underline-offset-2">114</a>.
      </p>
    </div>
  </div>
);
